import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SharedMessageModel } from '../models/shared-message.model';

@Injectable({
  providedIn: 'root',
})
export class SharedMessageService {
  public worker: SharedWorker;
  private messageSubject = new Subject<SharedMessageModel>();

  constructor() {
    if (typeof SharedWorker === 'undefined') {
      throw new Error('Shared Workers are not supported in this environment.');
    }
    this.worker = new SharedWorker('assets/shared-worker-echo.js');

    this.worker.port.onmessage = (event: MessageEvent) => {
      this.messageSubject.next(event.data);
    };

    this.worker.port.start();
  }

  /**
   * Sends a message to the shared worker.
   * @param message - The message to send THIS CAN BE STRUCTURED DATA
   */
  post(message: any): void {
    this.worker.port.postMessage(message);
  }

  close(): void {
    this.worker.port.close();
  }

  /**
   * Observable to receive messages from the shared worker.
   * @returns Observable<any> THIS CAN BE STRUCTURED DATA
   */
  receive(): Observable<SharedMessageModel> {
    return this.messageSubject.asObservable();
  }
}
